import { Platform } from 'react-native'
import { tokens } from '../vendor/tapestry/tokens'

export const MAX_FONT_SIZE_MULTIPLIER = 1.5
export const MAX_FONT_SIZE_MULTIPLIER_LANDMARK = 1.2 // Use in headers, footers, toolbars, etc.

export const CONVERSATION_MESSAGE_LIST_PADDING_HORIZONTAL = 16 // TODO: move to `screens/conversation/utils/styles` when `/screens/conversation` is created
export const MESSAGE_AUTHOR_AVATAR_COLUMN_WIDTH = 32 // TODO: move to `screens/conversation/utils/styles` when `/screens/conversation` is created

export const platformFontWeightMedium = Platform.select({
  ios: tokens.fontWeightMedium,
  android: tokens.fontWeightBold,
})

export const platformFontWeightBold = Platform.select({
  ios: tokens.fontWeightSemiBold,
  android: tokens.fontWeightBold,
})

export const platformPressedOpacityStyle = Platform.select({
  ios: { opacity: 0.5 },
  android: { opacity: 1 },
})
